module.exports = __webpack_public_path__ + "static/favicon-c7f17d7742c3880ba3af1e7a393f4818.ico";